var BOOKING = {
  experiences: [],
  cart: null,
  init: function () {
    CART.init();
    if (is_voucher) {
      CART.addVoucher(is_voucher);
    } else {
      CART.addVoucher(false);
    }
    // fill in with item from cart
    for (var index = 0; index < experiences.length; index++) {
      var xp = new CartItem(experiences[index]);
      xp.onupdate = BOOKING.updateTotals;
      xp.onChangeState = BOOKING.updateTotals;
      xp.setupFromStore(CART.getItem(xp.id));
      if (xp.id == main_id) {
        xp.active = true;
      }
      BOOKING.experiences.push(xp);
    }
    BOOKING.updateTotals();

    $(".booking-input-date").change(function () {
      //var activeXP = $('main').data('xp-id');
      var activeXP = $(this).data("id");
      //console.log('change date on booking ', activeXP);
      BOOKING.experiences.forEach((xp) => {
        //console.log(xp.id, $(this).val());
        if (xp.id == activeXP) {
          console.log("entrou crl");
          xp.date = $(this).val();
        }
      });

      CART.saveCart();
    });

    $("#xp-date, .booking-hours").change(function () {
      let data = $("#xp-date").val();
      let hours = $(".booking-hours option:selected").html();
      if (hours != "" && data != "") {
        let future = data.trim() + " " + hours.trim();
        let now = new Date();
        let futureDate = new Date(future);
        let diffMs = futureDate - now;
        let diffHours = diffMs / (1000 * 60 * 60);
        if (diffHours < 48) {
          $("#time_warning").removeClass("is-hidden");
          $(".booking-hours").val("");
          setTimeout(function () {
            $("#time_warning").addClass("is-hidden");
          }, 3000);
        }
      }
    })

    $(".section-booking-total .button").click(function (event) {
      var hasDate = false;
      if ($("#xp-date").length == 0) hasDate = true;
      else {
        hasDate = BOOKING.experiences
          .filter((xp) => xp.active)
          .every((xp) => !_.isEmpty(xp.date));
      }
      console.log("hasDate", hasDate);


      var hasLanguage = false;
      BOOKING.experiences.forEach((xp) => {
        if (xp.extras.language && xp.extras.language.value) {
          hasLanguage = true;
        }
      });

      var hasPerson = false;
      var hasPerson =
        _.find(BOOKING.experiences, { id: main_id.toString() }).personCount() >
        0;
      console.log("hasperson", hasPerson, main_id, hasDate);
      if (hasDate && hasPerson && hasLanguage) {
        BOOKING.addToShoppingCart();
      } else {
        if (!hasDate) {
          $("#xp-date").addClass("is-danger");
          console.log("nao tem data");
        }
        if (!hasPerson) {
          $(
            '[name="xp:' +
            main_id +
            '#extra:person"], [name="xp:' +
            main_id +
            '#extra:children"]'
          ).addClass("is-danger");
          console.log("nao tem person");
        }

        if (!hasLanguage) {
          let match = $('[name^="xp:"][name$="#extra:language"]').attr("name").match(/xp:(\d+)#extra:language/);
          let mainnumber = match ? match[1] : null;
          $('[name="xp:' + mainnumber + '#extra:language"]').parent().addClass("is-danger");
          console.log("nao tem language: " + mainnumber);
        }

        $(".section-booking-total .form-message").text(TOKEN.VALIDATE_FIELDS);
        event.preventDefault();
      }
    });
  },
  updateTotals: function () {
    console.log("updateTotals");
    for (var index = 0; index < BOOKING.experiences.length; index++) {
      $("#xp_" + BOOKING.experiences[index].id + "_price").text(
        BOOKING.experiences[index].computeItemTotal().toFixed(2) + "€"
      );
    }

    var booking_total = _.chain(BOOKING.experiences)
      .filter({ active: true })
      .map("total")
      .filter()
      .map(parseFloat)
      .sum()
      .value();

    $("#booking_total").text(booking_total.toFixed(2) + "€");
  },
  changeExperienceState: function (id, state) {
    const idx = _.findIndex(BOOKING.experiences, (xp) => xp.id == id);
    if (idx !== -1) {
      var hasPerson = BOOKING.experiences[idx].personCount() > 0;
      if (!hasPerson && state == true) {
        $(
          '[name="xp:' +
          id +
          '#extra:person"], [name="xp:' +
          id +
          '#extra:children"]'
        ).addClass("is-danger");
        console.log("nao tem person");
      } else {
        $(
          '[name="xp:' +
          id +
          '#extra:person"], [name="xp:' +
          id +
          '#extra:children"]'
        ).removeClass("is-danger");
        BOOKING.experiences[idx].changeExperienceState(state);
        if (!BOOKING.experiences[idx].date)
          BOOKING.experiences[idx].date = $("#xp-date").val();
        CART.removeItem(BOOKING.experiences[idx].id);
      }
    }
  },

  addToShoppingCart: function () {
    var itemsToAdd = BOOKING.experiences.filter((xp) => xp.active);
    for (var i = 0; i < itemsToAdd.length; i++) {
      console.log("AAAA, ", JSON.stringify(itemsToAdd[i]));
      let val = $(
        'select[name="xp:' + itemsToAdd[i].id + '#extra:schedule"]'
      ).val();
      if (val) {
        itemsToAdd[i].extras.schedule.value = val;
        console.log("VAL , ", val);
      }

      CART.addToCart(Object.assign({}, itemsToAdd[i]));
      // const element = itemsToAdd[i];
    }

    CART.saveCart();
  },
  finishBooking: function () {
    console.log("finishBooking ", CART.items);
    UTILS.blockUI(true);
    axios
      .post("/requests/create_sell.php", {
        items: CART.items,
        order_id: CART.order_id || null,
        discount: CART.discount || null,
        voucher: CART.voucher ? 1 : 0,
      })
      .then((response) => {
        CART.order_id = response.data.result.id;
        CART.saveCart();
        // CART.clear();
        window.location.href = response.data.redirect_url;
      })
      .catch((error) => {
        console.log(error.response.data);
        if (error.response.data.message)
          $(".form-message").html(error.response.data.message);
      })
      .finally(() => UTILS.blockUI(false));
  },
  payBooking: function () {
    FORMS.sendForm(
      event,
      "#form-pay",
      "choose_payment_method.php",
      function (form_name) {
        console.log("extra_validation on " + form_name);
        //if company or PT ask for a NIF (in theory nif is only mandatory above 100 eur)
        if (
          $("input[name='company']").val() != "" ||
          $("select[name=country]").val() == 227
        ) {
          if ($("input[name='nif']").val() == "") {
            FORMS.showUserMessage(
              "Por favor preencha o seu NIF correctamente",
              FORMS.MESSAGE_ERROR,
              "#form-pay-message",
              false
            );
            return false;
          }
        } else if ($("#form-pay #agree_pay:checked").length == 0) {
          FORMS.showUserMessage(
            TOKEN.TERMS_ERROR,
            FORMS.MESSAGE_ERROR,
            "#form-pay-message",
            false
          );
          return false;
        }
        var payment = $("input[name=payment_method]:checked").val();
        if (payment) {
          if (payment == "mbw") {
            if ($("#mobile-number").val() != "") {
              return true;
            } else {
              FORMS.showUserMessage(
                TOKEN.PHONE_MANDATORY_MBW,
                FORMS.MESSAGE_ERROR,
                "#form-pay-message",
                false
              );
            }
          } else return true;
        } else {
          FORMS.showUserMessage(
            TOKEN.PICK_PAYMENT_METHOD,
            FORMS.MESSAGE_ERROR,
            "#form-pay-message",
            false
          );
          return false;
        }
      },
      function (response) {
        console.log("ok callback", response, response.data.data, response.data.data.data, response.data.data.data.redirectUrl);

        if (response.data.data.url && response.data.data.url != "") {
          document.location.href = response.data.data.url;
        } else if (response.data.data.data.redirectUrl) {
          document.location.href = response.data.data.data.redirectUrl;
        } else if (response.data.data.redirect) {
          CART.clear();
          window.location.href = response.data.data.redirect;
        } else {
          $(".section-generic").removeClass("is-hidden");

          if (response.data.data.method == "mbw") {
            $(".section-checkout").addClass("is-hidden");
            $(".section-mbw").removeClass("is-hidden");
            CART.clear();
          } else if (response.data.data.method == "free") {
            $(".section-checkout").addClass("is-hidden");
            $(".section-free").removeClass("is-hidden");
            CART.clear();
          } else if (response.data.data.method == "mb") {
            console.log(response.data.data);
            $(".section-checkout").addClass("is-hidden");
            $(".section-mb").removeClass("is-hidden");
            $(".mb-entity .text").html(response.data.data.data.entity);
            $(".mb-reference .text").html(response.data.data.data.reference);
            $(".mb-value .text").html(response.data.data.data.value + " EUR");
            CART.clear();
          }
        }
      },
      function (error) {
        console.log("nok callback", error);
      },
      false
    );
  },
};
